<template>
  <div class="col-12 mb-1">
    <div class="form-check">
      <input @input="check"
      type="checkbox"
      :checked="checked"
      :id="fieldId"
      v-bind="$attrs"
      :disabled="disabled"
      class="form-check-input">
      <label class="form-check-label" :for="fieldId">
        {{ option.value }} <span class="form-check-sub-label">({{ option.count }})</span>
      </label>
    </div>
  </div>
</template>

<script>
import {computed} from "vue";

export default {
  name: 'FilterCheckbox',
  emits: ["toggled"],
  props: {
    option: {
      type: Object,
      required: true,
    },
    fieldId: {
      type: [Number, String],
      required: true,
    },
    selectedOptions: {
      type: Array,
      required: true,
    },
  },
  setup(props, context) {
    const checked = computed(() => props.selectedOptions.some(o => o.id === props.option.id))
    const disabled = computed(() => props.option.count <= 0)
    const check = () => {
      context.emit("toggled", props.option);
    }

    return {
      checked,
      disabled,
      check,
    };
  },
}
</script>